import CryptoJS from 'crypto-js'

const secretEncryptKey = process.env.SECRET_ENCRYPT_KEY || 'secret-key-nada-321'

export const encrypt = (inputText) => {
  try {
    return CryptoJS.AES.encrypt(
      JSON.stringify(inputText),
      secretEncryptKey
    ).toString()
  } catch (error) {
    console.log(error.message)
    return null
  }
}

export const decrypt = (inputText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(inputText, secretEncryptKey)
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
    return decryptedData
  } catch (error) {
    console.log(error.message)
    return null
  }
}
